import { ProductModel } from "../../product-models"
import { Action, ActionType } from "../actionTypes"

interface productState {
    loaded: boolean,
    pending: boolean,
    productData: ProductModel,
    error: string,
}

const initialState:productState = {
    loaded: false,
    pending: false,
    productData: null,
    error: null,
}

const productReducer = (state: productState = initialState, action: Action):productState => {
    switch (action.type) {
        case ActionType.REQUEST_PRODUCT_DATA:
            console.log("Req product data fired")
            return { ...state, pending: true }
        case ActionType.RECEIVE_PRODUCT_DATA:
            return {
                ...state,
                productData: action.payload,
                pending: false,
                loaded: true
            }
        case ActionType.EXPAND_DOWNLOAD_CAT:
            return {
                ...state,
                productData: {
                    ...state.productData,
                    ProductFiles: state.productData.ProductFiles.map(c => {
                        if (c.CategoryName === action.payload) {
                            c.IsExpanded = true;
                        }
                        return c;
                    })
                }
            }
        case ActionType.COLLAPSE_DOWNLOAD_CAT:
            return {
                ...state,
                productData: {
                    ...state.productData,
                    ProductFiles: state.productData.ProductFiles.map(c => {
                        if (c.CategoryName === action.payload) {
                            c.IsExpanded = false;
                        }
                        return c;
                    })
                }
            }
        default:
            return state
    }
}

export default productReducer;